<div *ngIf="tempoExpirar" class="aviso-token-expirando">
  <span class="mr-4" [translate]="'AVISO_TOKEN_EXPIRANDO'"
    [translateParams]="{ tempoExpirar: tempoExpirar * 1000 | date:'mm:ss'}"></span>
  <button type="button" class="btn-token-expirando" (click)="onRenewToken()">
    <i class="fa-solid fa-arrows-rotate mr-2"></i>
    <span [translate]="'ATUALIZAR_TOKEN'"></span>
  </button>
</div>
<div *ngIf="!tempoExpirar">
  <ng-content></ng-content>
</div>